import axios from 'axios'

import { authorizationHeaderInterceptor } from './configureInterceptors'

const ApiName = {
  CLIENTS: 'clients',
  CUSTOMERS: 'customers',
  ONBOARDINGS: 'onboardings',
  CONFIGS: 'configs'
}
class ApiClient {
  constructor() {
    const { VITE_APP_URL } = import.meta.env

    this.apiClient = axios.create({
      baseURL: `${VITE_APP_URL}`
    })

    authorizationHeaderInterceptor(this.apiClient.interceptors.request)
  }

  get(apiName, resource, config = {}) {
    const endpoint = resource
      ? `/${apiName || ''}/${resource}`.replace(/\/{2,}/g, '/')
      : `/${apiName}`
    const { params, headers, ...rest } = config

    return this.apiClient.get(endpoint, {
      ...rest,
      params,
      headers
    })
  }

  post(apiName, resource, data, headers = {}, extraConfig = {}) {
    const endpoint = resource ? `/${apiName}/${resource}` : `/${apiName}`
    return this.apiClient.post(endpoint, data, {
      headers: { ...headers },
      ...extraConfig
    })
  }

  patch(apiName, resource, data, headers = {}, extraConfig = {}) {
    const endpoint = resource ? `/${apiName}/${resource}` : `/${apiName}`
    return this.apiClient.patch(endpoint, data, {
      headers: { ...headers },
      ...extraConfig
    })
  }

  put(apiName, resource, data, headers = {}, extraConfig = {}) {
    const endpoint = resource ? `/${apiName}/${resource}` : `/${apiName}`
    return this.apiClient.put(endpoint, data, {
      headers: { ...headers },
      ...extraConfig
    })
  }

  delete(apiName, resource, id, extraConfig = {}) {
    const endpoint = resource ? `/${apiName}/${resource}/${id}` : `/${apiName}/${id}`
    return this.apiClient.delete(endpoint, { ...extraConfig })
  }
}

const apiClient = new ApiClient()

export const registerCustomers = (data) => {
  return apiClient.post(ApiName.CUSTOMERS, '', data)
}

export const checkCode = ({ refer_code, client_type, institution }) => {
  return apiClient.get(ApiName.ONBOARDINGS, `step1/subscriptionCodes/${refer_code}/valid`, {
    params: {
      clientType: client_type,
      institution
    }
  })
}

export const register = (data, institution) => {
  return apiClient.post(ApiName.ONBOARDINGS, 'step1', data, {}, { params: { institution } })
}

export const validateClientId = (clientId) => {
  return apiClient.get(ApiName.ONBOARDINGS, `step1/clients/${clientId}/exists`)
}

export const validateExistingEmail = (email) => {
  return apiClient.get(ApiName.ONBOARDINGS, 'step1/users/exists', {
    params: { email }
  })
}

export const fetchCachedFinishData = (token) => {
  return apiClient.get(null, 'onboardings/me/step2', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

export const getBanks = () => {
  return apiClient.get(null, 'banks')
}

export const getCountriesBanks = () => {
  return apiClient.get(ApiName.CONFIGS, 'banks')
}

export const uploadDocument = (file, onProgress) => {
  return apiClient.post(
    ApiName.CLIENTS,
    'me/onboarding/docs',
    file,
    { 'Content-Type': 'multipart/form-data' },
    {
      onUploadProgress: onProgress
    }
  )
}

export const finish = (data) => {
  return apiClient.post(ApiName.ONBOARDINGS, 'me/step2', data)
}
